import { THEMES, type Theme } from '@bingo/shared';
import { useAuth } from '../lib/auth';
import { useT } from '../lib/i18n';

const LABELS: Record<Theme, string> = { system: 'Auto', light: 'Light', dark: 'Dark' };

export function ThemeSwitch() {
  const { me, setTheme } = useAuth();
  const t = useT();
  const current = me?.user.theme ?? 'system';
  return (
    <div className="seg" role="group" aria-label={t('Theme')}>
      {THEMES.map((th) => (
        <button key={th} type="button" aria-pressed={current === th} onClick={() => setTheme(th)}>
          {t(LABELS[th])}
        </button>
      ))}
    </div>
  );
}
